// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1e8fef7e","453":"a95a873e","667":"bc235651"}[chunkId] + ".chunk.js";
};